let inject = ['$scope' ,'$sce', '$uibModalInstance','modalOptions'];

class ModalVideoController {
  constructor ($scope,$sce,$uibModalInstance,modalOptions) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.$sce=$sce;
    this.modalOptions = Object.assign({}, modalOptions);
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
  trustedUrl(url){
    return this.$sce.trustAsResourceUrl(url);
  }

  ok() {
    this.$uibModalInstance.close();
  }
}

ModalVideoController.$inject = inject;

export default ModalVideoController;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/modal-video/modal-video.controller.js
 **/